import { SliceCaseReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICommentsStorage {
  [key: string]: {
    uuid: string;
    count: number;
  }[];
}

interface AddCommentPayload {
  type: string;

  uuid: string;
  count: number;
}

interface RemoveCommentPayload {
  key: string;
  uuid: string;
}

interface UpdateCommentCountPayload {
  key: string;
  uuid: string;
  count: number;
}

export const slice = createSlice<ICommentsStorage, SliceCaseReducers<ICommentsStorage>>({
  name: 'comments',
  initialState: {},
  reducers: {
    setComment: (state, action: PayloadAction<AddCommentPayload>) => {
      const { type, uuid, count } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      const comment = state[type].find((comment) => comment.uuid === uuid);
      if (comment) {
        comment.count = count;
      } else {
        state[type].push({ uuid, count });
      }
    },
  },
});

export const { setComment } = slice.actions;

export const commentsSelector = (state: ICommentsStorage) => state.comments;
export const getCommentsCount = (state: ICommentsStorage, key: string, uuid: string) => {
  return state.comments[key]?.find((comment) => comment.uuid === uuid)?.count ?? 0;
};

export default slice.reducer;
